import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../../assets/img/pdf_icon_version4.png'
import _imports_1 from '../../../../../assets/img/excel_icon.jpg'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "row align-items-center justify-content-between" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "table-responsive overflow-auto" }
const _hoisted_6 = { class: "table table-striped" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import {computed, onMounted, ref} from 'vue';
import analyticsCoachService from '@/api/Analytics/MontlyList';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
// @ts-ignore
import {getAllUnemployedDropdown, getCoachDropdownForAnalytics, getOfficeByUserRoleDropdown, assistedLivingCoachingClassificationDropdown} from '@/shared/dropdowns';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Search from '@/views/App/Analytics/MontlyList/AssistedLivingCoaching/Search.vue';
import {downloadFile} from "@/shared/functions";
import BackButton from "@/components/button/BackButton.vue";

// ---------- Types ----------

interface ICoachingList{
  data: ICoachingData[],
  pagination: IPagination
}

interface ICoachingData{
  id: number;
  status: string;
  firstName: string;
  lastName: string;
  startDate: string;
  endDate: string;
  location: string;
  unitsDone: string;
  unitsDonePercent: string;
  protocolUnits?: number;
  firstInterviewUnits?: number;
}

interface IPagination {
  total_pages: number;
  current_page: number;
  items_per_page?: number;
}

interface IFilters {
  coachId: string;
  lastName: string;
  'officeIds[]': number[];
  clientId: string;
  status: string;
  startDate: string;
  endDate: string;
  page: number,
  limit: number,
}


// ---------- State ----------


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const unemployedStatusFiltered = computed(() =>
    piniaEnumsState.enums.unemployedStatus.filter(
        (status: any) => ['active', 'finished', 'new'].includes(status.value)
    )
);

const currentDate = new Date().getFullYear();
const classificationDropdown = assistedLivingCoachingClassificationDropdown();

const filters = ref<IFilters>({
  coachId: '',
  lastName: '',
  'officeIds[]': [],
  clientId: '',
  status: '',
  startDate: `01.01.${currentDate}`,
  endDate: `31.12.${currentDate}`,
  page: 1,
  limit: 10,
});

const coachingList = ref<ICoachingList>();
const coachDropdown = ref<any[]>([]);
const officeDropdown = ref<any[]>([]);
const unemployedDropdown = ref<any[]>([]);
const statusDropdown = ref<any[]>([]);

const isSearching = ref(false);
const isLoaded = ref(false);


// ---------- Methods ----------
async function getCoachingList(
    page = 1,
    perPage?: number,
    passedFilters?: IFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  const perPageRes = coachingList.value?.pagination?.items_per_page;

  try {
    const {data} = await analyticsCoachService.getAssistedLivingCoachingList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    console.log("DATA", data)
    coachingList.value = data;
    isSearching.value = false;
  } catch (error: any) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

const handleDropdownSearch = async (searchTerm: string , type: string) => {
  if (searchTerm.length < 3) return;

  const filters = {
    searchTerm: searchTerm,
    searchTermFor: type
  }

  if (type === 'lastName') await getAllUnemployedDropdown(
      unemployedDropdown,
      'lastName',
      'lastName',
      filters
  )
};

const handleClearDropdown = () => {
  unemployedDropdown.value = [];
}


// ---------- Lifecycle ----------
onMounted(async () => {
  await Promise.all([
    getCoachingList(),
    getOfficeByUserRoleDropdown(officeDropdown),
    getCoachDropdownForAnalytics(coachDropdown),
  ]);

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'analyticsHome' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex justify-content-between" }, [
              _createElementVNode("h6", { class: "element-header" }, " Anwesenheitsliste monatlich ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "form-header mb-4" }, "Betreutes Wohnen", -1)),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                classificationDropdown: _unref(classificationDropdown),
                officeDropdown: officeDropdown.value,
                coachDropdown: coachDropdown.value,
                statuDropdown: statusDropdown.value,
                unemployedDropdown: unemployedDropdown.value,
                statusDropdown: unemployedStatusFiltered.value,
                onSearch: getCoachingList,
                onDropdownFetch: handleDropdownSearch,
                onClearDropdown: handleClearDropdown
              }, null, 8, ["filters", "loading", "classificationDropdown", "officeDropdown", "coachDropdown", "statuDropdown", "unemployedDropdown", "statusDropdown"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(PerPage, {
                    values: [10, 25, 50, 100],
                    "onUpdate:perPage": getCoachingList
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "Vorname"),
                      _createElementVNode("th", null, "Nachname"),
                      _createElementVNode("th", null, "Standort"),
                      _createElementVNode("th", null, "Start"),
                      _createElementVNode("th", null, "Ende"),
                      _createElementVNode("th", { class: "text-end" }, "Stand"),
                      _createElementVNode("th", { class: "text-end" }, "Stand %"),
                      _createElementVNode("th", { class: "text-end" }, "Einheiten"),
                      _createElementVNode("th", { class: "text-center" }, "Anwesenheitsliste")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachingList.value?.data, (coaching) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coaching.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`coaching_status.${coaching?.status}`)), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.firstName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.lastName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.location), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.startDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.endDate), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(coaching?.unitsDone), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(coaching?.unitsDonePercent), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString((Number(coaching.protocolUnits) || 0) + (Number(coaching.firstInterviewUnits) || 0)), 1),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("a", {
                            target: "_blank",
                            class: "btn portal_pdf_export",
                            onClick: ($event: any) => (_unref(downloadFile)(`/portal/assisted-living-coaching/meeting-list-pdf/${coaching.id}`,
               undefined, filters.value))
                          }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "",
                              style: {"width":"45px","height":"55px"}
                            }, null, -1),
                            _createElementVNode("br", null, null, -1)
                          ]))], 8, _hoisted_11),
                          _createElementVNode("a", {
                            target: "_blank",
                            class: "btn portal_pdf_export",
                            onClick: ($event: any) => (_unref(downloadFile)(`/portal/assisted-living-coaching/meeting-list-excel/${coaching.id}`,
               undefined, filters.value, false ))
                          }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "",
                              style: {"width":"45px","height":"55px"}
                            }, null, -1),
                            _createElementVNode("br", null, null, -1)
                          ]))], 8, _hoisted_12)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (coachingList.value?.pagination?.total_pages ?? 0 > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: coachingList.value?.pagination?.total_pages,
                    currentPage: coachingList.value?.pagination?.current_page,
                    totalItems: coachingList.value?.pagination?.total_items,
                    perPage: coachingList.value?.pagination?.items_per_page,
                    onPagechanged: getCoachingList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})